import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import processError from '../../../utils/processError';
import {
  authorizedCheckSuccess,
  authorizedCheckFailed,
  authorizedLoginFailed,
  authorizedLogoutSuccessful,
} from '../actions';

export default function* authorizedCheck(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/auth/user`;
    const pool = {};
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const authorizedData = yield userDataResponse.json();
    if (userDataResponse.status === OK && authorizedData && authorizedData.data) {
      yield put(authorizedCheckSuccess(authorizedData.data));
      yield call(resolveActionPromise(action, authorizedData.data));
    } else {
      yield put(authorizedLoginFailed(authorizedData));
      yield put(authorizedCheckFailed(authorizedData));
      yield call(rejectActionPromise(action, authorizedData));
    }
  } catch (e) {
    yield put(authorizedLogoutSuccessful(e));
    yield processError(e);
  }
}
